import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { findOrCreate, findSettings } from '../../redux/actions/stores';
import { findPayment } from '../../redux/actions/payments';
import { getSettings } from '../../redux/actions/settings';

import SettingsPage from '../partials/SettingsPage';
import FeatureCard from '../partials/FeatureCard';
import LoadingPlaceholder from '../partials/LoadingPlaceholder';
import CancelledSubscriptionHeader from '../partials/CancelledSubscriptionHeader';

import MainError from './MainError';
import Payment from '../Payment';

import { Small } from '@bigcommerce/big-design';

const MainPage = ({ storeUserLoad, payload, checkoutSessionId, stores, users, payments, getPaymentStatus, findStoreSettings, settings, settingsLoad }) => {
  useEffect(() => {
    storeUserLoad(payload);
    if(!payments.isFetching){
      getPaymentStatus(payload);
    }
    settingsLoad(payload);
  }, [payload, storeUserLoad]);

  if (payments.status === 'success' && payments.paymentStatus !== 'trialing' && payments.paymentStatus !== 'active' && checkoutSessionId) {
    return (
      <Navigate to={`/payment_session/${checkoutSessionId}`} />
    )
  }

  if (payments.status === 'success' && (payments.paymentStatus === 'trialing' || payments.paymentStatus === 'active') && stores.status === 'success' && settings.status === 'success') {
    return(
      <SettingsPage title="Pack Perfect" description={<Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>}>
        <CancelledSubscriptionHeader />

        <FeatureCard
          title="App Settings"
          description="Manage app settings for Pack Perfect."
          buttonText="Settings"
          image={<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" viewBox="0 0 20 20"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 5.5a2.489 2.489 0 0 0-.5089-1.512c1.0017-1.0012 2.252-1.7536 3.6505-2.1566C7.9842 2.8034 8.9108 3.5 10 3.5s2.0157-.6966 2.3584-1.6686c1.3984.403 2.6488 1.1554 3.6505 2.1566A2.4885 2.4885 0 0 0 15.5 5.5C15.5 6.8807 16.6193 8 18 8c.0878 0 .1746-.0046.2601-.0134A8.5197 8.5197 0 0 1 18.5 10c0 .6936-.0831 1.3679-.2399 2.0133A2.5403 2.5403 0 0 0 18 12c-1.3807 0-2.5 1.1193-2.5 2.5 0 .5682.1895 1.0921.5089 1.5119-1.0017 1.0012-2.2521 1.7536-3.6505 2.1566C12.0157 17.1965 11.0892 16.5 10 16.5s-2.0157.6965-2.3584 1.6685c-1.3984-.403-2.6488-1.1554-3.6505-2.1566A2.4887 2.4887 0 0 0 4.5 14.5C4.5 13.1193 3.3807 12 2 12c-.0878 0-.1746.0045-.2601.0133A8.5204 8.5204 0 0 1 1.5 10c0-.6937.083-1.368.2399-2.0134A2.529 2.529 0 0 0 2 8c1.3807 0 2.5-1.1193 2.5-2.5zm5.5 7c1.3807 0 2.5-1.1193 2.5-2.5S11.3807 7.5 10 7.5 7.5 8.6193 7.5 10s1.1193 2.5 2.5 2.5z"/></svg>}
          linkUrl="/settings"
          stripeBackground='#943737'
        />
      </SettingsPage>
    )
  }

  if (payments.status === 'success' && (payments.paymentStatus === 'no payment found' ||  payments.paymentStatus === 'canceled') && stores.status === 'success' && !checkoutSessionId) {
    return (
      <Navigate to="/payment" />
    )
  }

  if (payments.status === 'success' && payments.paymentStatus !== 'no payment found' &&  payments.paymentStatus !== 'canceled' && stores.status === 'success' && payments.paymentStatus !== 'active' && payments.paymentStatus !== 'trialing' && !checkoutSessionId) {
    return (
      <MainError />
    )
  }

  return(
    <SettingsPage title="Pack Perfect" description="">
      <LoadingPlaceholder title="Pack Perfect" />
    </SettingsPage>
  )
}


const mapStateToProps = state => ({
  payments: state.payments,
  stores: state.stores,
  users: state.users,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  storeUserLoad: (payload) => dispatch(findOrCreate(payload)),
  findStoreSettings: (payload) => dispatch(findSettings(payload)),
  getPaymentStatus: (payload) => dispatch(findPayment(payload)),
  settingsLoad: (payload) => dispatch(getSettings(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
